<!-- <div mat-dialog-content fxLayout="row">
    <div fxLayout="column" fxLayoutGap="16px" fxFlex="30%">
        <ngx-spinner bdColor="rgb(255,255,255)" size="medium" color="#a0f078" type="ball-spin-clockwise"></ngx-spinner>

    </div>
    <div fxFlex fxLayout="column" fxLayoutGap="16px" fxFlex="40%">
        <p class="body-1">{{message}}</p>
    </div>
</div> -->

<ngx-spinner bdColor="rgb(255,255,255)" size="default" color="#a0f078" type="ball-spin-clockwise" [fullScreen]="true">
    <p style="color: white">{{message}}</p>

</ngx-spinner>